import React from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import { ButtonType } from 'shared/components/button/types/button-interface'

const PrimaryButton = (props: ButtonType) => (
  <BaseButton
    color={'text-background-secondary'}
    hoverColor={'hover:text-background-secondary'}
    backgroundColor={'bg-brand-primary'}
    hoverBackgroundColor={'hover:bg-brand-primary-hover'}
    {...props}
  />
)
export default PrimaryButton
